import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RestockLotesService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/restock-lotes', httpClient, authService);
  }

  crearConProduccion(dto: any): Observable<any> {
    return this.post(dto, 'produccion');
  }

  obtenerReporte(startDate: string, endDate: string): Observable<any[]> {
    return this.get(`reporte?startDate=${startDate}&endDate=${endDate}`) as Observable<any[]>;
  }
}
